<div class="shelf-packages-container">
    <h3>{{'BRANCHES.SHELF_PACKAGES' | translate}}</h3>
    <app-packages-table-view [packagesAPI]="packagesAPI"></app-packages-table-view>
</div>
